import ContractorRegistrationPage from "../../shared/contractor-registration/ContractorRegistrationPage";
import { CONTRACTOR_REGISTRATION_CONFIG } from "../../shared/contractor-registration/contractorRegistrationConfig";

export default function ManagementContractorRegistrationPage() {
  return (
    <ContractorRegistrationPage {...CONTRACTOR_REGISTRATION_CONFIG.management} />
  );
}
